import { Controller } from '@hotwired/stimulus';
import { renderStreamMessage } from '@hotwired/turbo';

export default class extends Controller {
  static values = { pending: Boolean, url: String };

  connect() {
    this.abortController = new AbortController();
    this.delay = 2000;
    if (this.pendingValue) this.schedule();
  }

  disconnect() {
    clearTimeout(this.timer);
    this.abortController.abort();
  }

  schedule() {
    this.timer = setTimeout(() => this.poll(), this.delay);
  }

  async poll() {
    const signal = this.abortController.signal;
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: 'text/vnd.turbo-stream.html' },
        signal
      });
      if ([403, 404].includes(response.status)) return;
      if (!response.ok || !response.headers.get('content-type')?.includes('text/vnd.turbo-stream.html')) {
        throw new Error('Could not check condition transfer');
      }
      const html = await response.text();
      if (!signal.aborted) renderStreamMessage(html);
    } catch {
      if (!signal.aborted) {
        this.delay = Math.min(this.delay * 2, 30000);
        this.schedule();
      }
    }
  }
}
